module.exports = __webpack_public_path__ + "static/media/wrenchLight.6c0cb8bd.svg";